import React from 'react'

import { webRTCContext } from './context'
import { WebRTC, WebRTCOptions } from './WebRTC'

export type WebRTCProviderProps = React.PropsWithChildren & {
  options: WebRTCOptions
}

export default function WebRTCProvider(props: WebRTCProviderProps): React.ReactElement {
  const webRTC = React.useMemo(() => {
    return new WebRTC({ serverUrl: props.options.serverUrl })
  }, [props.options.serverUrl])

  return <webRTCContext.Provider value={webRTC}>{props.children}</webRTCContext.Provider>
}
